/**
 * Utility functions for handling file types consistently across the application
 */

/**
 * Converts a MIME type or filename to a simple file extension format
 * e.g., "application/pdf" → "pdf", "document.docx" → "docx"
 */
export function simplifyFileType(fileType: string, fileName?: string): string {
  // Try to get extension from filename first if provided
  if (fileName) {
    const filenameParts = fileName.split('.');
    if (filenameParts.length > 1) {
      const extension = filenameParts.pop()!.toLowerCase();
      if (extension) return extension;
    }
  }
  
  // If no extension from filename, try to simplify the MIME type
  const mimeType = fileType.toLowerCase();
  
  // Handle common MIME types
  if (mimeType.includes('pdf')) return 'pdf';
  if (mimeType.includes('word') || mimeType.includes('document')) return 'doc';
  if (mimeType.includes('excel') || mimeType.includes('spreadsheet')) return 'xls';
  if (mimeType.includes('powerpoint') || mimeType.includes('presentation')) return 'ppt';
  if (mimeType.includes('jpeg') || mimeType.includes('jpg')) return 'jpg';
  if (mimeType.includes('png')) return 'png';
  if (mimeType.includes('gif')) return 'gif';
  if (mimeType.includes('mp3')) return 'mp3';
  if (mimeType.includes('mp4')) return 'mp4';
  if (mimeType.includes('wav')) return 'wav';
  if (mimeType.includes('ogg')) return 'ogg';
  if (mimeType.includes('zip') || mimeType.includes('compressed')) return 'zip';
  if (mimeType.includes('text/plain')) return 'txt';
  if (mimeType.includes('html')) return 'html';
  if (mimeType.includes('xml')) return 'xml';
  if (mimeType.includes('csv')) return 'csv';
  
  // For less common types, extract the subtype from mime type (after the '/')
  const parts = mimeType.split('/');
  if (parts.length > 1) return parts[1].split(';')[0].split('+')[0];
  
  // Fallback to original if we can't simplify
  return parts[0] || 'other';
}
